import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const fi: AppStrings = {
  // COMMON
  error_title: 'Virhe',
  cancel: 'Peruuta',
  retry: 'Yritä uudelleen',
  back_arrow: '← Takaisin',

  // ASK SCREEN
  ask_box_unavailable: 'Laatikko ei ole saatavilla',
  ask_box_unavailable_desc: 'Linkki saattaa olla vanhentunut tai omistaja on sulkenut laatikon.',
  ask_create_own_box: 'Luo oma laatikko',
  ask_sent_title: 'Lähetetty ✅',
  ask_sent_desc: 'Anonyymi kysymyksesi toimitettiin laatikon omistajalle.',
  ask_anonymous_hint: 'Kysymyksesi lähetetään anonyymisti.',
  ask_placeholder: 'Kirjoita kysymyksesi…',
  ask_send: 'Lähetä',
  ask_sending: 'Lähetetään…',
  ask_error_rate_limit: 'Liian monta pyyntöä — odota hetki.',
  ask_error_restart: 'Käynnistä Mini App uudelleen.',
  ask_error_load: 'Laatikon lataaminen epäonnistui.',
  ask_error_send: 'Kysymyksen lähettäminen epäonnistui.',
  ask_error_banned: 'Sinut on estetty sovelluksessa.',
  ask_banned_appeal_btn: 'Valita',
  ask_appeal_sent: 'Valitus lähetetty. Käsittelemme sen manuaalisesti.',

  // AGE GATE
  age_gate_title: 'Vain 18+',
  age_gate_desc:
    'Lähetät anonyymin kysymyksen. Ole kunnioittava: häirintä, uhkaukset, alaikäisiin kohdistuva seksuaalinen sisältö ja lainvastainen sisältö on kielletty. Anonymiteetti ei tarkoita rankaisemattomuutta — rikkomukset ilmoitetaan moderaatiolle. Lähettämällä kysymyksen vahvistat olevasi 18+ ja hyväksyväsi säännöt.',
  age_gate_confirm: 'Olen 18+ — jatka',

  // INBOX SCREEN
  inbox_title: 'Oma laatikkosi',
  box_link_accordion: 'Kutsulinkki',
  inbox_notifications_ask: '🔔 Saako botti lähettää ilmoituksia uusista kysymyksistä?',
  inbox_notifications_allow: 'Salli',
  inbox_notifications_dismiss_label: 'Sulje',
  inbox_box_toggle_disable: 'Poista kysymykset käytöstä',
  inbox_box_toggle_enable: 'Ota kysymykset käyttöön',
  inbox_box_disabled_warning: 'Kysymykset on poistettu käytöstä — uusia kysymyksiä ei hyväksytä.',
  inbox_share_hint: 'Jaa linkki, niin kaverisi voivat kysyä sinulta anonyymejä kysymyksiä.',
  inbox_copy: 'Kopioi',
  inbox_copied: 'Kopioitu',
  inbox_copy_error: 'Virhe',
  inbox_no_deeplink: 'Linkki ilmestyy deployn jälkeen.',
  inbox_invite_story: 'Kutsu Storyn kautta',
  inbox_invite_chat: 'Kutsu chatin kautta',
  inbox_card_rendering: 'Kutsukorttia luodaan vielä.',
  inbox_story_unsupported:
    'Storyt eivät ole saatavilla tässä Telegram-versiossa. Kokeile "chatin kautta".',
  inbox_story_error: 'Storyn avaaminen epäonnistui.',
  inbox_chat_unsupported:
    'Chat-jakaminen ei ole saatavilla tässä Telegram-versiossa. Päivitä asiakas.',
  inbox_chat_error: 'Jakaminen epäonnistui. Yritä uudelleen.',
  inbox_chat_prepare_error: 'Kutsun valmistelu epäonnistui.',
  inbox_filter_incoming: 'Saapuneet',
  inbox_filter_hidden: 'Piilotetut',
  inbox_filter_blocked: 'Estetyt',
  inbox_filter_empty: 'Täällä ei ole vielä mitään.',
  inbox_acc_unanswered: 'Vastaamattomat',
  inbox_acc_answered: 'Vastatut',
  inbox_acc_hidden: 'Piilotetut',
  inbox_acc_blocked: 'Estetyt',
  inbox_empty: 'Ei vielä kysymyksiä. Jaa yllä oleva linkki.',
  inbox_load_more: 'Lataa lisää',
  inbox_load_more_error: 'Seuraavan sivun lataaminen epäonnistui.',
  inbox_error_load: 'Laatikon lataaminen epäonnistui.',
  inbox_rate_limit: 'Liian monta pyyntöä — odota hetki.',
  inbox_toggle_error: 'Laatikon tilan muuttaminen epäonnistui.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Kirjoita minulle anonyymisti',
  message_placeholder: 'Kirjoita viesti…',
  message_anonymous_hint: 'Viestisi lähetetään anonyymisti.',
  message_sent_title: 'Lähetetty ✅',
  message_sent_desc: 'Anonyymi viestisi on toimitettu.',
  message_owner_entry: 'Kirjoita minulle',
  message_share_hint: 'Jaa linkki, niin kuka tahansa voi lähettää sinulle anonyymin viestin.',
  message_inbox_open: 'Vastaanotetut viestit',
  message_inbox_title: 'Viestit',
  message_inbox_empty: 'Ei vielä viestejä. Jaa yllä oleva linkkisi.',

  // ANSWER SCREEN
  answer_title: 'Vastaa kysymykseen',
  answer_placeholder: 'Kirjoita vastauksesi…',
  answer_submit: 'Lähetä',
  answer_submitting: 'Lähetetään…',
  answer_back: 'Takaisin',
  answer_error_send: 'Vastauksen lähettäminen epäonnistui.',

  // SHARE SCREEN
  share_title: 'Vastaus julkaistu ✅',
  share_hint: 'Jaa kortti ja kerää lisää kysymyksiä.',
  share_card_rendering_desc:
    'Korttia luodaan vielä. Palaa kysymyksiin ja tarkista hetken kuluttua — voit sitten jakaa sen Storyssa tai chatissa.',
  share_card_alt: 'Vastauskortti',
  share_story_btn: 'Jaa Storyyn',
  share_story_btn_busy: 'Avataan…',
  share_chat_btn: 'Jaa chattiin',
  share_chat_btn_busy: 'Valmistellaan…',
  share_back: 'Takaisin kysymyksiin',
  share_story_unsupported:
    'Storyt eivät ole saatavilla tässä Telegram-versiossa. Kokeile "Jaa chattiin".',
  share_story_error: 'Storyn avaaminen epäonnistui. Kokeile "Jaa chattiin".',
  share_chat_sent: 'Viesti lähetetty.',
  share_chat_unsupported:
    'Chat-jakaminen ei ole saatavilla tässä Telegram-versiossa. Päivitä asiakas.',
  share_chat_error: 'Jakaminen epäonnistui. Yritä uudelleen.',
  share_chat_prepare_error: 'Viestin valmistelu epäonnistui.',

  // LEADERBOARD SCREEN
  lb_title: 'Tulostaulukko',
  lb_period_7d: '7 päivää',
  lb_period_30d: '30 päivää',
  lb_period_all: 'Kaikki aikainen',
  lb_group_label: 'Kategoria',
  lb_group_all: 'Kaikki',
  lb_group_ask: 'Kysymykset',
  lb_group_rate: 'Arvostelu',
  lb_group_confession: 'Tunnustus',
  lb_group_guesswho: 'Arvaa kuka',
  lb_group_message: 'Viestit',
  lb_error: 'Tulostaulukon lataaminen epäonnistui',
  lb_empty: 'Ei vielä ketään tulostaulukossa',
  lb_anon: 'Anonyymi',
  lb_load_more: 'Lataa lisää',
  lb_questions: (n) => plural('fi', n, { one: '{n} kysymys', other: '{n} kysymystä' }),
  lb_referrals: (n) => plural('fi', n, { one: '{n} suositus', other: '{n} suositusta' }),

  // REWARDS SCREEN
  rw_title: 'Omat palkinnot',
  rw_error: 'Palkintojen lataaminen epäonnistui',
  rw_level: (n) => `Taso ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('fi', n, { one: '{n} vahvistettu suositus', other: '{n} vahvistettua suositusta' }),
  rw_next_level_section: (n) =>
    plural('fi', n, { one: 'SEURAAVA TASO — {n} suositus', other: 'SEURAAVA TASO — {n} suositusta' }),
  rw_to_level: (level, target) => `tasolle ${level}: ${target}`,
  rw_max_level: 'Maksimitaso saavutettu!',
  rw_badges_section: 'MERKIT',
  rw_formats_section: 'LAATIKKOFORMAATIT',

  // QUESTION CARD
  qcard_status_new: 'Uusi',
  qcard_status_hidden: 'Piilotettu',
  qcard_status_answered: 'Vastattu',
  qcard_moderation_flagged: 'Huomio: epäilyttävä viesti',
  qcard_answer_btn: 'Vastaa',
  qcard_answer_send: 'Lähetä',
  qcard_share_btn: 'Jaa',
  qcard_hide_btn: 'Piilota',
  qcard_show_btn: 'Näytä',
  qcard_report_btn: 'Ilmianna',
  qcard_block_btn: 'Estä',
  qcard_unblock_btn: 'Poista esto',
  qcard_report_reason_label: 'Valitse ilmiantosyy:',
  qcard_reason_spam: 'Roskaposti',
  qcard_reason_harassment: 'Häirintä',
  qcard_reason_sexual: 'Seksuaalinen sisältö',
  qcard_reason_other: 'Muu',
  qcard_error_hide: 'Näkyvyyden muuttaminen epäonnistui.',
  qcard_error_report: 'Ilmiannon lähettäminen epäonnistui.',
  qcard_error_block: 'Lähettäjän estäminen epäonnistui.',
  qcard_report_done: 'Ilmianto lähetetty — kiitos.',
  qcard_block_done: 'Lähettäjä estetty.',
  qcard_unblock_done: 'Lähettäjän esto poistettu.',

  // ERRORS (common humanized error messages)
  err_network: 'Ei yhteyttä palvelimeen. Tarkista internet-yhteys ja yritä uudelleen.',
  err_server_unavailable: 'Palvelin on tilapäisesti poissa käytöstä, yritä myöhemmin.',
  err_internal: 'Jotain meni pieleen meidän päässä. Tutkimme asiaa — yritä myöhemmin.',
  err_bad_request: 'Tarkista syöttämäsi tiedot.',
  err_generic: 'Toimintoa ei voitu suorittaa, yritä myöhemmin.',
  err_schema: 'Tietovirhe. Kokeile päivittää sovellus.',
  share_story_link_premium_note:
    'Klikattava linkki Storyssa vaatii Telegram Premiumin. Ilman sitä kaverisi löytävät sinut silti — käyttäjätunnuksesi näkyy kortilla.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Pääsyvirhe',
  auth_error_desc:
    'Todennus epäonnistui. Sulje Mini App ja avaa se uudelleen Telegramista.',

  // REWARD TOAST
  reward_toast_title: 'Uusi palkinto!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Kysymykset',
  tab_leaderboard: 'Tulostaulukko',
  tab_rewards: 'Palkinnot',
  tab_settings: 'Asetukset',

  // SETTINGS SCREEN
  settings_title: 'Asetukset',
  settings_section_general: 'Yleiset',
  settings_notifications: 'Ilmoitukset uusista kysymyksistä',
  settings_notifications_hint: 'Botti lähettää sinulle viestin, kun joku kysyy kysymyksen.',
  settings_notifications_error: 'Ilmoitusasetuksen tallentaminen epäonnistui.',
  settings_language: 'Kieli',
  settings_language_error: 'Kieltä ei voitu vaihtaa. Yritä uudelleen.',
  settings_section_about: 'Tietoja sovelluksesta',
  settings_version: 'Versio',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story-linkit ovat vain Premiumille',
  code_modal_explain:
    'Telegram antaa klikattavan story-linkin vain Premium-tilaajille. Lisää sen sijaan koodi Storyysi — katsojat kirjoittavat sen sovellukseen ja kysyvät sinulta anonyymin kysymyksen.',
  code_modal_your_code: 'Oma koodisi',
  code_modal_copy: 'Kopioi koodi',
  code_modal_copied: 'Kopioitu',
  code_modal_share_btn: 'Jaa Storyyn',
  code_modal_loading: 'Haetaan koodia…',
  code_modal_error: 'Koodia ei voitu hakea. Yritä myöhemmin.',
  ask_code_title: 'Syötä koodi',
  ask_code_desc:
    'Tulit Storysta? Etsi sieltä koodi (esim. 1234) ja kirjoita se alle.',
  ask_code_placeholder: 'Koodi Storysta',
  ask_code_find: 'Etsi',
  ask_code_not_found: 'Koodia ei löydy. Tarkista numerot ja yritä uudelleen.',
  ask_code_invalid: 'Koodi on 4 numeroa.',
  code_onboarding_header: 'Tulit Storysta?',
  code_onboarding_text: 'Kirjoita kaverin koodi ja kysy häneltä anonyymi kysymys.',
  code_onboarding_action: 'Syötä koodi',
  settings_ask_by_code: 'Kysy koodilla',
  settings_my_code_title: 'Oma story-koodisi',
  settings_my_code_hint:
    'Kirjoita tämä koodi Storyysi — katsojat kirjoittavat sen kysyäkseen sinulta anonyymin kysymyksen. Telegram antaa klikattavat story-linkit vain Premium-tilaajille.',
  settings_my_code_rotate: 'Hanki uusi koodi',
  settings_my_code_rotating: 'Päivitetään…',
  settings_my_code_done: 'Koodi päivitetty',
  settings_my_code_error: 'Koodia ei voitu hakea.',
  settings_my_code_rotate_confirm_title: 'Vaihdetaanko koodi?',
  settings_my_code_rotate_confirm_desc:
    'Vanha koodisi lakkaa toimimasta heti. Kukaan story-julkaisusi nähnyt ei enää tavoita sinua. Vaihda vain, jos joku spämmää sinua.',
  settings_my_code_rotate_confirm_action: 'Vaihda koodi',

  // BOT
  bot_greeting: (name) => (name ? `Hei, ${name}! 👋` : 'Hei! 👋'),
  bot_onboarding:
    'Tämä on VeylMe — anonyymit kysymykset.\n\n' +
    'Avaa Mini App, julkaise kortti «Kysy minulta anonyymisti» Storyssäsi — ' +
    'ja vastaanota anonyymit kysymykset suoraan tänne.\n\n' +
    '⚠️ 18+. Ole kunnioittava: kiusaaminen, uhkaukset ja kielletty sisältö ' +
    'eivät ole sallittuja. Anonymiteetti ≠ rankaisemattomuus — rikkomukset menevät moderointiin.',
  bot_open_btn: 'Avaa VeylMe',
  notify_answer_btn: 'Vastaa',
  bot_invite_text:
    'Joku jakoi VeylMe-linkin.\n\n' +
    'Avaa Mini App esittääksesi anonyymin kysymyksen:',
  bot_invite_btn: 'Kysy anonyymisti',

  // WORK-027 i18n sweep
  tagline: 'Kysy minulta anonyymisti',
  share_ask_action: 'Kysy',
  share_answered_text: 'Vastasin anonyymiin kysymykseen 👀',
  err_not_in_telegram: 'Mini App ei toimi Telegramissa. Käynnistä sovellus uudelleen.',
  badge_viral_starter: 'Viraali alku',
  badge_storyteller: 'Tarinankertoja',
  badge_loop_master: 'Kierron mestari',
  theme_confession: 'Tunnustukset',
  theme_guesswho: 'Arvaa kuka',
  rw_format_named: (name) => `formaatti «${name}»`,
  card_label_question: 'Kysymys',
  card_label_answer: 'Vastaus',
  card_invite_subtitle: 'anonyymi, ei rekisteröitymistä',
  card_code_hint: 'SYÖTÄ KOODI SOVELLUKSEEN',
  share_msg_title: (brand) => `${brand} · Anonyymit kysymykset`,
  notify_new_question: '🔔 Joku esitti sinulle anonyymin kysymyksen',
  notify_unanswered_reminder: (n) =>
    plural('fi', n, { one: '🔔 Sinulla on {n} vastaamaton kysymys', other: '🔔 Sinulla on {n} vastaamatonta kysymystä' }),
  notify_ban_permanent: 'pysyvästi',
  notify_ban_until: (date) => `${date} saakka`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Sinut on estetty VeylMessä ${untilPhrase}. Liian moni vastaanottaja on ilmoittanut viesteistäsi.\nJos uskot tämän olevan virhe, voit lähettää valituksen sovelluksessa.`,
  notify_warning_msg:
    '⚠️ Useampi vastaanottaja on ilmoittanut viesteistäsi. Vielä muutama ja sinut estetään VeylMessä.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Omat kysymykseni',
  my_questions_empty_title: 'Et ole vielä esittänyt kysymyksiä',
  my_questions_empty_desc: 'Kysy jotain jonkun laatikkoon — vastaus ilmestyy tänne.',
  my_questions_loading: 'Tarkistetaan vastausta…',
  my_questions_waiting: 'Odottaa vastausta',
  my_questions_answer_label: 'Vastaus',
  settings_my_questions: 'Omat kysymykseni',
  ask_sent_find_reply_hint: 'Löydät vastauksen myöhemmin kohdasta «Omat kysymykseni».',
  inbox_story_nonpremium_hint: 'Story-linkki ei ole klikattava ilman Telegram Premiumia, joten näytämme koodin — jakaminen chatissa on luotettavampaa.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram-käyttölupasi on vanhentunut',
  session_expired_desc: 'Telegram antaa sovellukselle luvan vain kerran käynnistyksessä, ja tämä on jo vanhentunut. Avaa sovellus uudelleen — aloittamasi tekstin tallensimme.',
  session_expired_desc_no_storage: 'Telegram-käyttölupasi on vanhentunut, ja sovellus täytyy avata uudelleen. Emme voineet tallentaa kirjoittamaasi tekstiä — kopioi se ennen kuin poistut.',
  session_expired_reopen: 'Avaa uudelleen',
  session_expired_stuck_title: 'Telegram antoi saman vanhan luvan',
  session_expired_stuck_desc: 'Sulje sovellus kokonaan botin valikosta ja avaa se uudelleen — silloin Telegram antaa uuden luvan.',
  session_auth_failed_title: 'Kirjautumista ei voitu vahvistaa',
  session_auth_failed_desc: 'Telegram ei vahvistanut kirjautumistasi sovellukseen. Sulje sovellus ja avaa se uudelleen botin chatista.',
  session_expired_manual_close: 'Sovellus ei voi sulkea itseään täältä — sulje se itse ja avaa uudelleen botin chatista.',
  session_expiring_soon: 'Telegram-käyttölupasi vanhenee pian. Avaa sovellus uudelleen, ettei mikään katoa.',
  my_questions_check_failed: 'Vastauksia ei voitu tarkistaa. Yritä myöhemmin uudelleen.',
  settings_notifications_load_error: 'Asetusta ei voitu ladata.',
};
